import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database';


import { Http, Response } from '@angular/http';
import {Headers} from '@angular/http';

@Component({
  selector: 'app-declaracao-final-cqt',
  templateUrl: './declaracao-final-cqt.component.html',
  styleUrls: ['./declaracao-final-cqt.component.scss']
})
export class DeclaracaoFinalCqtComponent implements OnInit {

  id;
  dec;
  constructor(private route: ActivatedRoute,
    private router: Router, private db: AngularFireDatabase, private http: Http) { 
      if (!this.route.snapshot.params['id']) {
        this.router.navigate(['/declaracao-view-cqt']);
      }
      this.id = this.route.snapshot.params['id'];
      console.log(this.id);
      this.db.database.ref(`approvedDeclarations/imobiliaria-cqt/${this.id}`).once('value').then(res => {
        if (!res) {
          this.close();
        }
        console.log(res);
        console.log(res.val());
        this.dec = res.val();
        this.dec.id = res.key;
        this.id = res.key;
      });
    }

    two(x) {
      if (x.toString().length === 1) {
        return '0' + x;
      }
      return x;
    }
  
    formatDate(x) {
      const d = new Date(x);
      return this.two(d.getDate()) + '/' + this.two((d.getMonth() + 1)) + '/' + d.getFullYear() + ' - ' +
      this.two(d.getHours()) + ':' + this.two(d.getMinutes()) + ':' + this.two(d.getSeconds());
    }
    formatNasc(x) {
      x = x.toString();
      return x.slice(0, 2) + '/' + x.slice(2, 4) + '/' + x.slice(4);
    }
  
    formatIdentidade(x) {
      x = x.toString();
      return x;
      // return x.slice(0, 2) + '.' + x.slice(2, 5) + '.' + x.slice(5, 8) + '-' + x.slice(8);
    }

    ngOnInit() {
   
  }

  close() {
    this.router.navigate(['/declaracao-view-cqt']);
  }


  getYear() {
    const d = new Date(this.dec.created);
    return d.getFullYear();
  }

  getDay() {
    const d = new Date(this.dec.created);
    return String(d.getDate()).padStart(2, '0')
  }

  getMonth() {
    const d = new Date(this.dec.created);
    const m = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho',
               'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    return m[d.getMonth()];
  }

  getMes() {
    return String(new Date(this.dec.created).getMonth() + 1).padStart(2, '0');
  }

  getTermino() {
    const d = new Date(this.dec.created);
    d.setMonth(d.getMonth() + 6);
    return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() +1).padStart(2, '0') + '/' + d.getFullYear();
  }

  getMatricula() {
    const d  = new Date();

    // tslint:disable-next-line:max-line-length
    return this.getYear().toString() + this.getMes().toString() + this.getDay().toString() + d.getHours().toString() + d.getMinutes().toString() + d.getSeconds().toString();
  }



}
